<template>
  <div class="credit-skeleton">
    <div class="credit-skeleton__header">
      <div class="credit-skeleton__header-title">Total usage</div>
      <div class="credit-skeleton__header-skeleton">
        <div class="credit-skeleton__header-skeleton-item" />
      </div>
    </div>
    <div class="credit-skeleton__bar">
      <div class="credit-skeleton__bar-skeleton">
        <div class="credit-skeleton__bar-skeleton-item" />
      </div>
    </div>
    <div class="credit-skeleton__content">
      <div class="credit-skeleton__content-skeleton">
        <div class="credit-skeleton__content-skeleton-left">
          <div
            class="credit-skeleton__content-skeleton-item credit-skeleton__content-skeleton-item-1"
          />
          <div
            class="credit-skeleton__content-skeleton-item credit-skeleton__content-skeleton-item-2"
          />
          <div
            class="credit-skeleton__content-skeleton-item credit-skeleton__content-skeleton-item-3"
          />
          <div
            class="credit-skeleton__content-skeleton-item credit-skeleton__content-skeleton-item-4"
          />
        </div>
        <div class="credit-skeleton__content-skeleton-right">
          <div
            class="credit-skeleton__content-skeleton-item credit-skeleton__content-skeleton-item"
          />
          <div
            class="credit-skeleton__content-skeleton-item credit-skeleton__content-skeleton-item"
          />
          <div
            class="credit-skeleton__content-skeleton-item credit-skeleton__content-skeleton-item"
          />
          <div class="credit-skeleton__content-skeleton-item" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/uiKit/assets/fonts.scss';

.credit-skeleton {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-self: center;
  gap: var(--size-4);
  width: 100%;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &-skeleton {
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      gap: var(--size-2);

      &-item {
        height: 20px;
        width: 60px;
        border-radius: 20px;
        background-color: var(--color-surface-secondary);
      }
    }

    &-title {
      @include fontRegularBody100;
      color: var(--color-text-default);
      font-weight: 600;
    }

    &-value {
      @include fontRegularBody100;
      color: var(--color-text-default);
      font-weight: 500;
    }
  }

  &__bar {
    &-skeleton {
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      gap: var(--size-2);

      &-item {
        height: 8px;
        width: 100%;
        border-radius: 20px;
        background-color: var(--color-surface-secondary);
      }
    }
  }

  &__content {
    &-skeleton {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      gap: var(--size-2);

      &-left {
        display: flex;
        width: 200px;
        flex-grow: 1;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: var(--size-2);
      }

      &-right {
        display: flex;
        width: 45px;
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-start;
        gap: var(--size-2);
      }

      &-item {
        height: 20px;
        width: 100%;
        border-radius: 20px;
        background-color: var(--color-surface-secondary);

        &-1 {
          width: 60%;
        }

        &-2 {
          width: 50%;
        }

        &-3 {
          width: 40%;
        }

        &-4 {
          width: 30%;
        }
      }
    }

    &-expansion {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: calc(100% + var(--size-4));
      margin: 0 calc(var(--size-2) * -1);
      padding-bottom: 0;

      &-item {
        width: 100%;
      }

      &-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: var(--size-2);

        &-left {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: var(--size-2);

          &-icon {
            width: var(--size-2);
            height: var(--size-2);
            border-radius: 50%;
          }

          &-title {
            @include fontRegularBody100;
            color: var(--color-text-default);
          }
        }

        &-right {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          gap: var(--size-1);

          &-used {
            @include fontRegularBody100;
            color: var(--color-text-subtle);
          }
        }
      }

      &-content {
        display: flex;
        padding: 0 30px 0 var(--size-10);
        flex-direction: column;
        gap: var(--size-2);

        &-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: var(--size-5);
          gap: var(--size-1);

          &-label {
            @include fontRegularBody100;
            color: var(--color-text-subtle);
          }

          &-value {
            @include fontRegularBody100;
            color: var(--color-text-subtlest);
          }
        }
      }
    }
  }
}
</style>
